"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Position = exports.Trade = exports.SIAPY = exports.Fee = void 0;
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
const MethodConfig_1 = __importDefault(require("../../interface/MethodConfig"));
const config_1 = __importDefault(require("../../config"));
class Fee {
}
exports.Fee = Fee;
;
class SIAPY {
}
exports.SIAPY = SIAPY;
;
class Trade {
}
exports.Trade = Trade;
;
class Position {
}
exports.Position = Position;
;
class StartPosition {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.COMPLETELY;
        this.id = 'xBifi.startPosition';
        this.entryPointID = 'xBifi';
        this.defaultDecimals = new bifrost_number_1.default('10').pow(config_1.default.default.decimals);
    }
    getMethodProps() {
        return [new MethodConfig_1.default('xBifi.startPosition', [], 'xBifi'), new MethodConfig_1.default('bifi.si', [], 'bifi')];
    }
    proccessCallResponse(responses, isValidAddress, network, currency, args) {
        const position = (responses[0] || [])[0] || [];
        const si = responses[1] || [];
        const netLTV = new bifrost_number_1.default(position[7] || '0').div(this.defaultDecimals).toStr();
        const collateralAmount = new bifrost_number_1.default(position[2] || '0').div(this.defaultDecimals).toStr();
        const bifiFee = new bifrost_number_1.default(position[12] || '0').div(this.defaultDecimals).toStr();
        const flashLoanFeeAmount = new bifrost_number_1.default(position[8] || '0').div(this.defaultDecimals).toStr();
        const flashLoanFeeRate = new bifrost_number_1.default(position[10] || '0').div(this.defaultDecimals).toStr();
        const uniswapFeeAmount = new bifrost_number_1.default(position[9] || '0').div(this.defaultDecimals).toStr();
        const uniswapFeeRate = new bifrost_number_1.default(position[11] || '0').div(this.defaultDecimals).toStr();
        const collateralFeeAmount = new bifrost_number_1.default(position[13] || '0').div(this.defaultDecimals).toStr();
        const collateralFeeRate = new bifrost_number_1.default(position[14] || '0').div(this.defaultDecimals).toStr();
        const depositAmount = new bifrost_number_1.default(position[3] || '0').div(this.defaultDecimals).toStr();
        const depositAPY = new bifrost_number_1.default(position[0] || '0').div(this.defaultDecimals).toStr();
        const borrowAmount = new bifrost_number_1.default(position[4] || '0').div(this.defaultDecimals).toStr();
        const borrowAPY = new bifrost_number_1.default(position[1] || '0').div(this.defaultDecimals).toStr();
        const rawSIMarket = si[1] || [];
        const depositHandlerID = parseInt(args.srcHandlerID);
        const borrowHandlerID = parseInt(args.dstHandlerID);
        const depositTokenSIMarket = rawSIMarket.find(market => parseInt(market[0]) === depositHandlerID) || [];
        const borrowTokenSIMarket = rawSIMarket.find(market => parseInt(market[0]) === borrowHandlerID) || [];
        const depositSIAPY = {
            deposit: new bifrost_number_1.default(depositTokenSIMarket[4] || '0').div(this.defaultDecimals).toStr(),
            borrow: new bifrost_number_1.default(depositTokenSIMarket[5] || '0').div(this.defaultDecimals).toStr()
        };
        const borrowSIAPY = {
            deposit: new bifrost_number_1.default(borrowTokenSIMarket[4] || '0').div(this.defaultDecimals).toStr(),
            borrow: new bifrost_number_1.default(borrowTokenSIMarket[5] || '0').div(this.defaultDecimals).toStr()
        };
        const flashloanFee = {
            amount: flashLoanFeeAmount,
            rate: flashLoanFeeRate
        };
        const uniswapFee = {
            amount: uniswapFeeAmount,
            rate: uniswapFeeRate
        };
        const collateralFee = {
            amount: collateralFeeAmount,
            rate: collateralFeeRate
        };
        const deposit = {
            amount: depositAmount,
            apy: depositAPY,
            siAPY: depositSIAPY
        };
        const borrow = {
            amount: borrowAmount,
            apy: borrowAPY,
            siAPY: borrowSIAPY
        };
        return {
            netLTV,
            collateralAmount,
            bifiFee,
            flashloanFee,
            uniswapFee,
            collateralFee,
            deposit,
            borrow
        };
    }
}
exports.default = StartPosition;
;
//# sourceMappingURL=StartPosition.js.map